<template>
  <div>
    <div style="margin-top: 5px">
      <div style="margin-bottom: -20px; position: relative; z-index: 1">
        <!-- chọn trạng thái -->
        <el-select
            style="width: 120px"
            class="input-common"
            v-model="dataSearch.status"
            @change="changeSearchMethod()"
            placeholder="Trạng thái"
        >
          <el-option
              v-for="item in kidStatusList"
              :key="item.key"
              :value="item.key"
              :label="item.value"
          ></el-option>
        </el-select>
        <!-- chọn nhóm -->
        <el-select
            v-if="activeTabName === 'tabName3' || activeTabName === 'tabName4'"
            @change="changeSearchMethod"
            class="input-common input-grade"
            style="width: 203px"
            v-model="dataSearch.idGroup"
            placeholder="Chọn nhóm"
        >
          <el-option
              v-for="(item,index) in kidGroupList"
              :key="index"
              :value="item.id"
              :label="item.nameGroup"
          ></el-option>
        </el-select>
        <!-- chọn khối -->
        <el-select
            v-if="activeTabName === 'tabName1' || activeTabName === 'tabName2'"
            class="input-common input-grade"
            style="width: 110px"
            v-model="dataSearch.idGrade"
            @change="changeGradeSearch()"
            placeholder="Chọn khối"
        >
          <el-option
              v-for="item in gradeOfSchoolList"
              :key="item.id"
              :value="item.id"
              :label="item.gradeName"
          ></el-option>
        </el-select>

        <!-- chọn lớp -->
        <el-select
            v-if="activeTabName === 'tabName1' || activeTabName === 'tabName2'"
            class="input-common input-class"
            style="width: 120px"
            v-model="dataSearch.idClass"
            placeholder="Chọn lớp"
            @change="changeSearchMethod()"
        >
          <el-option
              v-for="item in classList"
              :key="item.id"
              :value="item.id"
              :label="item.className"
          ></el-option>
        </el-select>
        <el-input
            style="width: 220px"
            placeholder="Nhập tên học sinh"
            clearable
            v-model="dataSearch.fullName"
            @clear="changeSearchMethod()"
            @keyup.enter.native="changeSearchMethod()"
        >
          <el-button
              slot="append"
              icon="el-icon-search"
              @click="changeSearchMethod()"
          ></el-button>
        </el-input>
      </div>

      <el-tabs type="card" @tab-click="handleClickTab" v-model="activeTabName">
        <!-- danh sách khoản các khoản trong một lớp -->
        <el-tab-pane label="Đăng ký theo lớp" name="tabName1">
          <el-table
              ref="multipleTable"
              :data="responseTab1DataList"
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChangeKids"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                type="selection"
                align="center"
                width="55"
            ></el-table-column>
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="fullName"
                min-width="170"
                label="Họ tên"
            ></el-table-column>
            <el-table-column label="Ngày sinh" align="center" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.birthDay | formatDate }}</span>
              </template>
            </el-table-column
            >
            <!-- danh sách khoản -->
            <el-table-column
                align="center"
                v-for="(item) in headerTab1List"
                :key="item.id"
            >
              <template slot="header" slot-scope="scope">
                <el-popover
                    placement="top"
                    align="center"
                    width="200"
                    trigger="hover"
                    :content="item.name"
                >
                 <span
                     slot="reference"
                     class="truncate-text"
                     :title="item.name"
                 >
                    {{ item.name }}
                  </span>

                </el-popover>
                <br/>
                <br/>
                <el-checkbox
                    @change="
                    checkHeaderPackageKidsMethod(
                      scope.$index,
                      item.id,
                      item.check
                    )
                  "
                    v-model="item.check"
                ></el-checkbox>
                <!-- Dấu * có tooltip -->
                <el-tooltip content="Khoản ngoài lớp" placement="top" v-if="item.type === 'OUTCLASS'">
                  <span style="color: red; margin-left: 4px; cursor: pointer;">*</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span
                    v-if="
                    scope.row.fnKidsPackageList.filter(
                      (x) => x.fnPackage.id === item.id
                    ).length === 1
                  "
                >
                  <el-checkbox
                      v-model="
                      scope.row.fnKidsPackageList.filter(
                        (x) => x.fnPackage.id === item.id
                      )[0].active
                    "
                  ></el-checkbox>
                </span>
              </template>
            </el-table-column>
            <el-table-column
                label="Tác vụ"
                fixed="right"
                width="200"
                align="center"
            >
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="primary"
                    @click="addPackageKidsMethod(scope.row, 'CLASS')"
                >Thêm
                </el-button
                >
                <el-button
                    size="mini"
                    type="success"
                    @click="activePackageKidsOneMethod(scope.row)"
                >Lưu
                </el-button
                >

              </template>
            </el-table-column>
          </el-table>
          <div style="float: right; margin-top: 20px">
            <el-button
                :loading="loadingButtonSaveTab1"
                class="button-bottom"
                type="success"
                @click="activePackageKidsManyMethod()"
            >Lưu
            </el-button
            >
          </div>
        </el-tab-pane>

        <!-- list chi tiết học sinh -->
        <el-tab-pane label="Chi tiết học sinh theo lớp" name="tabName2">
          <el-table
              ref="kidsPackageForKidsRef"
              :data="responseTab2DataList"
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              :cell-style="tableRowStyleDetail"
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column type="expand" width="1">
              <template slot-scope="scope">
                <el-table
                    ref="kidsPackageForKidsRef1"
                    :data="scope.row.revenueManagementResponses"
                    :empty-text="textTable"
                    :element-loading-text="$tableLoading"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255,255,255, 0)"
                    highlight-current-row
                    :cell-style="tableRowStyleChildren"
                    :header-cell-style="tableHeaderChildrenColor"
                    :max-height="$tableMaxHeightMini"
                    border
                >
                  <el-table-column
                      fixed
                      type="index"
                      label="STT"
                      width="50"
                      align="center"
                  ></el-table-column>
                  <el-table-column
                      fixed
                      label="Tên khoản"
                      prop="name"
                      min-width="150"
                  ></el-table-column>
                  <el-table-column fixed align="center" label="Trạng thái sử dụng">
                    <template slot-scope="childScope">
                      <el-checkbox
                          v-model="childScope.row.active"
                          @change="activePackageKidsMethod(childScope.row, scope.row)"
                      ></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="Loại" width="80" prop="category">
                    <template slot-scope="scope">
                      <span v-if="scope.row.category === 'in'"
                      >Thu</span
                      >
                      <span v-else-if="scope.row.category === 'out'"
                      >Chi</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="description"
                      label="Mô tả"
                      min-width="200"
                  ></el-table-column>
                  <el-table-column
                      prop="number"
                      align="center"
                      label="Số lượng"
                      width="80"
                  ></el-table-column>
                  <el-table-column align="right" label="Đơn giá" width="120">
                    <template slot-scope="scope">
                      <span>{{ scope.row.price | formatCurrency }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="discount"
                      align="center"
                      label="Giảm giá"
                      width="80"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.discount">Có</span>
                      <span v-else>Không</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="discountPrice"
                      align="right"
                      label="Đơn giá sau giảm"
                      width="120"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.discount">{{
                          scope.row.discountPrice | formatCurrency
                        }}</span>
                      <span v-else>{{ scope.row.price | formatCurrency }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="Điểm danh" width="85">
                    <template slot-scope="scope">
                      <span v-if="scope.row.attendance">Có</span>
                      <span v-else>Không</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="Tác vụ"
                      fixed="right"
                      width="140"
                      align="center"
                  >
                    <template slot-scope="parentScope">
                      <span>
                        <el-button
                            :disabled="parentScope.row.type === 'CLASS'"
                            size="mini"
                            type="danger"
                            @click="deletePackageDefaultMethod(scope.row, parentScope.row)"
                        >{{ $t("button.delete") }}</el-button
                        >
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                width="200"
                prop="fullName"
                label="Họ tên"
            ></el-table-column>
            <el-table-column label="Ngày sinh" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.birthDay | formatDate }}</span>
              </template>
            </el-table-column
            >
            <el-table-column label="Số khoản" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.revenueManagementResponses.length }}</span>
              </template>
            </el-table-column
            >
            <el-table-column label="Tác vụ" width="110" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.revenueManagementResponses.length > 0">
                  <el-button
                      v-if="scope.row.expandRow"
                      size="mini"
                      type="primary"
                      @click="toogleExpandDetailDate(scope.$index, scope.row)"
                  >Thu nhỏ</el-button
                  >
                  <el-button
                      v-else
                      type="primary"
                      size="mini"
                      @click="toogleExpandDetailDate(scope.$index, scope.row)"
                  >Mở rộng</el-button
                  >
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="Đăng ký theo nhóm" name="tabName3">
          <el-table
              ref="multipleTable2"
              :data="responseTab3DataList"
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChangeKids"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                type="selection"
                align="center"
                width="55"
            ></el-table-column>
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="fullName"
                min-width="170"
                label="Họ tên"
            ></el-table-column>
            <el-table-column label="Ngày sinh" align="center" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.birthDay | formatDate }}</span>
              </template>
            </el-table-column
            >
            <!-- danh sách khoản -->
            <el-table-column
                align="center"
                v-for="(item) in headerTab3List"
                :key="item.id"
            >
              <template slot="header" slot-scope="scope">
                <el-popover
                    placement="top"
                    align="center"
                    width="200"
                    trigger="hover"
                    :content="item.name"
                >
                 <span
                     slot="reference"
                     class="truncate-text"
                     :title="item.name"
                 >
                    {{ item.name }}
                  </span>

                </el-popover>
                <br/>
                <br/>
                <el-checkbox
                    @change="
                    checkHeaderPackageKidsMethod(
                      scope.$index,
                      item.id,
                      item.check
                    )
                  "
                    v-model="item.check"
                ></el-checkbox>
                <!-- Dấu * có tooltip -->
                <el-tooltip content="Khoản ngoài nhóm" placement="top" v-if="item.type === 'OUTGROUP'">
                  <span style="color: red; margin-left: 4px; cursor: pointer;">*</span>
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span
                    v-if="
                    scope.row.fnKidsPackageList.filter(
                      (x) => x.fnPackage.id === item.id
                    ).length === 1
                  "
                >
                  <el-checkbox
                      v-model="
                      scope.row.fnKidsPackageList.filter(
                        (x) => x.fnPackage.id === item.id
                      )[0].active
                    "
                  ></el-checkbox>
                </span>
              </template>
            </el-table-column>
            <el-table-column
                label="Tác vụ"
                fixed="right"
                width="200"
                align="center"
            >
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="primary"
                    @click="addPackageKidsMethod(scope.row, 'GROUP')"
                >Thêm
                </el-button
                >
                <el-button
                    size="mini"
                    type="success"
                    @click="activePackageKidsOneMethod(scope.row)"
                >Lưu
                </el-button
                >

              </template>
            </el-table-column>
          </el-table>
          <div style="float: right; margin-top: 20px">
            <el-button
                :loading="loadingButtonSaveTab1"
                class="button-bottom"
                type="success"
                @click="activePackageKidsManyMethod()"
            >Lưu
            </el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane label="Chi tiết học sinh theo nhóm" name="tabName4">
          <el-table
              ref="kidsPackageForKidsRef2"
              :data="responseTab4DataList"
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              :cell-style="tableRowStyleDetail"
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column type="expand" width="1">
              <template slot-scope="scope">
                <el-table
                    ref="kidsPackageForKidsRef4"
                    :data="scope.row.revenueManagementResponses"
                    :empty-text="textTable"
                    :element-loading-text="$tableLoading"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255,255,255, 0)"
                    highlight-current-row
                    :cell-style="tableRowStyleChildren"
                    :header-cell-style="tableHeaderChildrenColor"
                    :max-height="$tableMaxHeightMini"
                    border
                >
                  <el-table-column
                      fixed
                      type="index"
                      label="STT"
                      width="50"
                      align="center"
                  ></el-table-column>
                  <el-table-column
                      fixed
                      label="Tên khoản"
                      prop="name"
                      min-width="150"
                  ></el-table-column>
                  <el-table-column fixed align="center" label="Trạng thái sử dụng">
                    <template slot-scope="childScope">
                      <el-checkbox
                          v-model="childScope.row.active"
                          @change="activePackageKidsMethod(childScope.row, scope.row)"
                      ></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="Loại" width="80" prop="category">
                    <template slot-scope="scope">
                      <span v-if="scope.row.category === 'in'"
                      >Thu</span
                      >
                      <span v-else-if="scope.row.category === 'out'"
                      >Chi</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="description"
                      label="Mô tả"
                      min-width="200"
                  ></el-table-column>
                  <el-table-column
                      prop="number"
                      align="center"
                      label="Số lượng"
                      width="80"
                  ></el-table-column>
                  <el-table-column align="right" label="Đơn giá" width="120">
                    <template slot-scope="scope">
                      <span>{{ scope.row.price | formatCurrency }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="discount"
                      align="center"
                      label="Giảm giá"
                      width="80"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.discount">Có</span>
                      <span v-else>Không</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="discountPrice"
                      align="right"
                      label="Đơn giá sau giảm"
                      width="120"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.discount">{{
                          scope.row.discountPrice | formatCurrency
                        }}</span>
                      <span v-else>{{ scope.row.price | formatCurrency }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="Điểm danh" width="85">
                    <template slot-scope="scope">
                      <span v-if="scope.row.attendance">Có</span>
                      <span v-else>Không</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="Tác vụ"
                      fixed="right"
                      width="140"
                      align="center"
                  >
                    <template slot-scope="parentScope">
                      <span>
                        <el-button
                            :disabled="parentScope.row.type === 'GROUP'"
                            size="mini"
                            type="danger"
                            @click="deletePackageDefaultMethod(scope.row, parentScope.row)"
                        >{{ $t("button.delete") }}</el-button
                        >
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                width="200"
                prop="fullName"
                label="Họ tên"
            ></el-table-column>
            <el-table-column label="Ngày sinh" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.birthDay | formatDate }}</span>
              </template>
            </el-table-column
            >
            <el-table-column label="Số khoản" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.revenueManagementResponses.length }}</span>
              </template>
            </el-table-column
            >
            <el-table-column label="Tác vụ" width="110" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.revenueManagementResponses.length > 0">
                  <el-button
                      v-if="scope.row.expandRow"
                      size="mini"
                      type="primary"
                      @click="toogleExpandDetailDateGroup(scope.$index, scope.row)"
                  >Thu nhỏ</el-button
                  >
                  <el-button
                      v-else
                      type="primary"
                      size="mini"
                      @click="toogleExpandDetailDateGroup(scope.$index, scope.row)"
                  >Mở rộng</el-button
                  >
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <AddRevenueOutClassDialog
        :idKid="idKid"
        :type="type"
        :dialogVisibleAdd="dialogVisibleAdd"
        :idClass="dataSearch.idClass"
        :idGroup="dataSearch.idGroup"
        @dialog-close="dialogCloseAddRevenueOutClassDialog"
    />
  </div>
</template>

<script>
import {kidStatusList} from "@/constant/listCommon";
import {mapState} from "vuex";
import revenueManagementService from "@/services/Finance_Kids_V2/RevenueManagementService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import AddRevenueOutClassDialog from "@/components/FinanceVer2/TuitionManagement/dialog/AddRevenueOutClassDialog.vue";

const valMonthList = [
  {key: "pastMonth", value: "Tháng trước"},
  {key: "nowMonth", value: "Tháng hiện tại"},
  {key: "nextMonth", value: "Tháng kế tiếp"},
];

export default {
  name: "RegisterRevenue",
  components: {
    AddRevenueOutClassDialog
  },
  data() {
    return {
      textTable: "",
      loadingData: true,
      activeTabName: "tabName1",
      multipleSelectionKids: [],
      multipleSelectionDefault: [],
      loadingButtonSaveTab1: false,
      loadingButtonGenerateTab1: false,
      loadingButtonTab2: false,
      loadingButtonTab3: false,
      loadingButtonExtend: false,
      responseTab3DataList: [],
      responseTab2DataList: [],
      responseTab4DataList: [],
      headerTab2List: [],
      responseTab1DataList: [],
      headerTab1List: [],
      headerTab3List: [],
      monthList: valMonthList,
      showCreateDialog: false,
      showUpdateDialog: false,
      showAddDefaultPackage: false,
      showAddPackageKids: false,
      showPackageKidsDetail: false,
      showPackageDefaultKid: false,
      showUpdatePackageKidsDialog: false,
      showAddPackageInClassDialog: false,
      showCreateExtendDialog: false,
      showAddPackageInKidsDialog: false,
      showDeleteManyDialog: false,
      showDeleteDefaultManyDialog: false,
      showAddDefaultExcludeClassDialog: false,
      showDiscountPackageDialog: false,
      showDiscountPackageDefaultDialog: false,
      kidStatusList,
      // nowDate: "",
      dataSearch: {
        date: "",
        month: "nowMonth",
        status: "STUDYING",
        idClass: "",
        idGrade: "",
        fullName: "",
        idGroup: "",
      },
      dialogVisibleAdd: false,
      idKid: 0,
      kidGroupList: [],
      type: ""
    };
  },
  created() {
    this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList');
    this.$store.dispatch('classStore/fetchDataClassListCommon');
    this.getAllGroup();
  },
  computed: {
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapState('classStore', ['classListCommon']),
    classList() {
      return this.classListCommon.filter((x) => x.idGrade === this.dataSearch.idGrade);
    },
  },
  watch: {
    gradeOfSchoolList: {
      immediate: true, // Kích hoạt ngay lập tức khi component được tạo
      handler(newVal) {
        if (newVal.length > 0) {
          this.getIdGrade();
        }
      },
    },
    classList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.getIdClass();
        }
      },
    }
  },
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    tableHeaderChildrenColor() {
      return "background-color: #b0d3f7;color: #606266;";
    },
    tableRowStyleDetail({row}) {
      if (row.expandRow) {
        return "font-weight: bold";
      }
    },
    tableRowStyleChildren({row}) {
      if (row.category === "out") {
        return "color: #409EFF";
      }
    },
    async handleClickTab(tab) {
      let tabNameClick = tab.name;
      if (tabNameClick === "tabName1") {
        await this.searchKidsPackageForKidsByProperties();
        await this.searchClassPackageByProperties();
      } else if (tabNameClick === "tabName2") {
        await this.searchKidsPackageForKidsByProperties();
      } else if (tabNameClick === "tabName3") {
        await this.searchKidsPackageForKidsByGroup();
        await this.searchGroupPackageByProperties();
      } else if (tabNameClick === "tabName4") {
        await this.searchKidsPackageForKidsByGroup();
      }
    },
    handleSelectionChangeKids(val) {
      this.multipleSelectionKids = val;
    },
    toogleExpandDetailDate(index, row) {
      row.expandRow = !row.expandRow;
      let $kidsPackageForKidsRef = this.$refs.kidsPackageForKidsRef;
      $kidsPackageForKidsRef.toggleRowExpansion(row);
    },
    toogleExpandDetailDateGroup(index, row) {
      row.expandRow = !row.expandRow;
      let $kidsPackageForKidsRef2 = this.$refs.kidsPackageForKidsRef2;
      $kidsPackageForKidsRef2.toggleRowExpansion(row);
    },
    activePackageKidsMethod(packageRow, kidRow, type) {
      let idClass = "0"
      let idGroup = "0"
      if (type === 'CLASS'){
        idClass = this.dataSearch.idClass;
      }
      if (type === 'GROUP'){
        idClass = this.dataSearch.idGroup;
      }
      revenueManagementService.studentRevenueChangeActive(kidRow.id, packageRow.id, packageRow.type, packageRow.active, idClass, idGroup)
          .then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công")
          })
          .catch((err) => {
            console.log(err)
            NotifyMessage.leftCornerNotificationError("Thay đổi thất bại");
          });
    },
    deletePackageDefaultMethod(row, packageRow) {
      this.$confirm(
          "Bạn có chắc chắn muốn xóa khoản này không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(() => {
        this.loadingData = true;
        if (this.activeTabName === "tabName4"){
          this.dataSearch.idClass = "0";
        }
        if (this.activeTabName === "tabName2"){
          this.dataSearch.idGroup = "0";
        }
        revenueManagementService.deleteStudentManagement(row.id, packageRow.id, packageRow.type, this.dataSearch.idClass, this.dataSearch.idGroup)
            .then(() => {
              NotifyMessage.leftCornerNotificationSuccess("Xóa thành công!")
              if (packageRow.type === 'OUTCLASS'){
                this.searchKidsPackageForKidsByProperties()
              }else {
                this.searchKidsPackageForKidsByGroup()
              }
            })
            .catch((err) => {
              console.log(err)
              NotifyMessage.leftCornerNotificationError("Xóa thất bại!")
            });
      });
    },

    checkBeforeSelect(list) {
      if (list.length === 0) {
        NotifyMessage.leftCornerNotificationError("Không có học sinh nào được chọn!")
        throw null;
      }
    },

    /**
     * click check header ở khoản mặc định
     */
    checkHeaderPackageKidsMethod(index, id, check) {
      this.responseTab1DataList.forEach((x) => {
        let filterList = x.fnKidsPackageList.filter(
            (a) => a.fnPackage.id === id
        );
        if (filterList.length === 1) {
          filterList[0].active = check;
        }
      });
      console.log("check : ", this.responseTab1DataList)
    },

    /**
     * kích hoạt/hủy kích hoạt khoản cho một học sinh
     */
    activePackageKidsOneMethod(row) {
      revenueManagementService.activeKidsPackageOne(row)
          .then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Lưu thay đổi thành công!")
            this.searchClassPackageByProperties();
          })
          .catch((err) => {
            NotifyMessage.leftCornerNotificationError(err.response.data.message);
          });
    },
    async dialogCloseAddRevenueOutClassDialog() {
      this.dialogVisibleAdd = false
      await this.searchClassPackageByProperties();
      await this.searchGroupPackageByProperties()
    },

    addPackageKidsMethod(row, type) {
      this.type = type;
      this.idKid = row.id;
      this.dialogVisibleAdd = true;
    },

    /**
     * kích hoạt/hủy kích hoạt khoản cho nhiều học sinh
     */
    activePackageKidsManyMethod() {
      let selectRowList = this.multipleSelectionKids;
      this.checkBeforeSelect(selectRowList);
      this.loadingButtonSaveTab1 = true;
      this.loadingData = true;
      revenueManagementService.activeKidsPackageMany(selectRowList)
          .then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Lưu thay đổi thành công")
            this.searchClassPackageByProperties();
          })
          .catch(() => {
            NotifyMessage.leftCornerNotificationError("Lưu thay đổi thất bại");
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingButtonSaveTab1 = false;
            }, 500);
          });
    },

    /**
     * thêm khoản
     */
    createDialogMethod() {
      setTimeout(() => {
        this.showCreateDialog = true;
      }, 100);
    },

    async changeSearchMethod() {
      if (this.activeTabName === "tabName1") {
        await this.searchKidsPackageForKidsByProperties();
        await this.searchClassPackageByProperties();
      } else if (this.activeTabName === "tabName2") {
        await this.searchKidsPackageForKidsByProperties();
      } else if (this.activeTabName === "tabName3") {
        await this.searchKidsPackageForKidsByGroup();
        this.searchGroupPackageByProperties();
      } else if (this.activeTabName === "tabName4") {
        await this.searchKidsPackageForKidsByGroup();
      }
    },
    /**
     * đối khối
     */
    changeGradeSearch() {
      this.getIdClass();
    },
    getIdGrade() {
      this.dataSearch.idGrade = this.gradeOfSchoolList[0].id;
    },
    getIdClass() {
      this.dataSearch.idClass = this.classList[0].id;
      this.changeSearchMethod();
    },

    /**
     * tìm kiếm các khoản theo lớp
     */
    async searchClassPackageByProperties() {
      this.textTable = "";
      this.loadingData = true;
      this.headerTab1List = []
      this.responseTab1DataList = []
      await revenueManagementService.searchKidsPackageInClass(
          this.dataSearch.status,
          this.dataSearch.fullName,
          this.dataSearch.idClass, 0
      )
          .then((resp) => {
            this.headerTab1List = resp.data.data.packageList;
            this.responseTab1DataList = resp.data.data.dataList;
          })
          .catch((err) => {
            NotifyMessage.leftCornerNotificationError(err.response.data.message)
            this.responseTab1DataList = [];
            this.headerTab1List = [];
          })
          .finally(() => {
            if (this.responseTab1DataList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            setTimeout(() => {
              this.loadingData = false;
            }, 300);
          });
    },
    /**
     * tìm kiếm các khoản theo group
     */
    async searchGroupPackageByProperties() {
      this.textTable = "";
      this.loadingData = true;
      this.headerTab3List = []
      this.responseTab3DataList= []
      if (this.dataSearch.idGroup !== '') {
        await revenueManagementService.searchKidsPackageInGroup(
            this.dataSearch.status,
            this.dataSearch.fullName,
            0, this.dataSearch.idGroup
        )
            .then((resp) => {
              this.responseTab3DataList = resp.data.data.dataList;
              this.headerTab3List = resp.data.data.packageList;
            })
            .catch((err) => {
              NotifyMessage.leftCornerNotificationError(err.response.data.message)
              this.responseTab3DataList = [];
              this.headerTab3List = [];
            })
            .finally(() => {
              if (this.responseTab3DataList.length === 0) {
                this.textTable = this.$tableEmpty;
              }
              setTimeout(() => {
                this.loadingData = false;
              }, 300);
            });
      } else {
        this.loadingData = false;
      }

    },
    /**
     * Thông tin chi tiết khoản của học sinh theo lớp
     */
    async searchKidsPackageForKidsByProperties() {
      this.textTable = "";
      this.loadingData = true;
      await revenueManagementService.searchStudentRevenueForClass(
          this.dataSearch.status,
          this.dataSearch.fullName,
          this.dataSearch.idClass, 0
      )
          .then((resp) => {
            this.responseTab2DataList = resp.data.data;
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
            this.responseTab2DataList = [];
          })
          .finally(() => {
            if (this.responseTab2DataList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            setTimeout(() => {
              this.loadingData = false;
            }, 300);
          });
    },
    /**
     * Thông tin chi tiết khoản của học sinh theo nhóm
     */
    async searchKidsPackageForKidsByGroup() {
      this.textTable = "";
      this.loadingData = true;
      if (this.dataSearch.idGroup !== '') {
        await revenueManagementService.searchStudentRevenueForGroup(
            this.dataSearch.status,
            this.dataSearch.fullName,
            0, this.dataSearch.idGroup
        )
            .then((resp) => {
              this.responseTab4DataList = resp.data.data;
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
              this.responseTab4DataList = [];
            })
            .finally(() => {
              if (this.responseTab4DataList.length === 0) {
                this.textTable = this.$tableEmpty;
              }
              setTimeout(() => {
                this.loadingData = false;
              }, 300);
            });
      } else {
        this.loadingData = false;
      }

    },
    /**
     * tìm tất cả các nhóm trong một trường
     */
    getAllGroup() {
      revenueManagementService.getListKidsGroup().then((res) => {
        this.kidGroupList = res.data
        if (this.kidGroupList.length > 0) {
          this.dataSearch.idGroup = this.kidGroupList[0].id
        }
      }).catch(() => {
        NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!")
      })
    },


  },

};
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #78a5e7;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

/deep/ .el-table .cell {
  line-height: 15px;
}

/deep/ .el-table th > .cell {
  font-size: 13px;
}

/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}

/deep/ .el-table td {
  padding: 8px 0;
}

/deep/ .el-table th {
  padding: 12px 0;
}

/deep/ .el-icon-arrow-right:before {
  content: "";
}

.input-common {
  margin-right: 5px;
}

.button-bottom {
  border-radius: 0;
  margin-left: 5px;
}

.button-click {
  float: right;
  margin: 20px 0 40px 0;
}

.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 0;
  margin: 3px 0;
  background-color: #5fb44a;
  border: 1px solid #ebeef5;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 #0000001a;
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

.over-table {
  width: 97%;
  margin: 0 auto;
}

.table-data {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;

  // display: inline-block;
}

.wrapper-table {
  height: 600px;
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

thead {
  background: #78a5e7;
  color: white;
  font-weight: bold;
  // display: block;
  // width: 90%;
}

tbody {
  color: #606266;
  font-size: 14px;
  overflow: auto;
  font-family: Arial, Helvetica, sans-serif;
}

td {
  padding: 12px;
}

.table-index {
  width: 10px;
  text-align: center;
}

.table-item-name {
  width: 200px;
  text-align: center;
}

.table-action {
  width: 200px;
  text-align: center;
}

.color-text-reply {
  color: #4177e2;
}

.input-data {
  width: 60%;
}

.disable-row {
  background: #e4e7ed;
}

.truncate-text {
  display: inline-block;
  max-width: 150px; /* điều chỉnh theo cần thiết */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>
